import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
  },
  accordionSummary: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
  circle: {
    position: 'relative',
    width: '3vw',
    height: '3vw',
    borderRadius: '50%',
    background: '#000A8C',
  },
  number: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: '#fff',
    fontSize: 12,
  },
  summaryText: {
    width: '70%',
    marginLeft: '12px',
  },
  summaryTextH6: {
    fontSize: 14,
    fontFamily: 'Poppins',
    fontWeight: 700,
    color: '#0E1247',
    display: 'flex',
    alignItems: 'center',
  },
  summaryTextSpan: {
    fontFamily: 'Poppins !important',
    fontWeight: 700,
    color: '#0E1247',
    '& *': {
      marginTop: '0px !important',
      marginBottom: '0px !important',
      fontFamily: 'Poppins !important',
      lineHeight: 1.5,
    },
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: '0px',
  },
  iconButton: {
    padding: '12px 6px 12px 12px',
    '& img': {
      width: 20,
      height: 20,
    },
  },
  accordionDetails: {
    color: theme.palette.primary.dark,
    '& *': {
      marginTop: '0px !important',
      marginBottom: '0px !important',
      fontFamily: 'Poppins !important',
    },
  },
  variableNameLabel: {
    color: theme.palette.primary.dark,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 700,
    paddingLeft: 10,
  },
  variableNameText: {
    color: theme.palette.success.dark,
    fontFamily: 'Poppins',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 700,
    textTransform: 'uppercase',
    paddingLeft: 3,
  },
}));

export default useStyles;
